import { render, staticRenderFns } from "./ReceiptPrint.vue?vue&type=template&id=72726c66"
import script from "./ReceiptPrint.vue?vue&type=script&lang=js"
export * from "./ReceiptPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports